import { ViewFactory } from 'wdc-cube-react'
import BorderoScope, { HeaderScope } from '../bordero.scopes'
import HeaderView from './bordero.header'
import BorderoView from './bordero.view'

export function registerViews(rv = ViewFactory.register) {
    rv(BorderoScope, BorderoView)
    rv(HeaderScope, HeaderView)
}
